"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

interface SuccessPhoneVerifiedProps {
  onNextAction: () => void;
}

export default function SuccessPhoneVerified({ onNextAction }: SuccessPhoneVerifiedProps) {
  const t = useTranslations("auth");
  return (
    <div className="text-center space-y-6 pt-2">
      <h2 className="text-2xl font-bold tracking-tight text-foreground">Phone verified</h2>
      <p className="text-sm text-muted-foreground">You’re all set. Head to your feed to start exploring.</p>
      <Button onClick={onNextAction} className="w-full min-h-[48px] py-6 text-base rounded-full touch-manipulation" size="lg">
        Continue to feed
      </Button>
    </div>
  );
}
